import { Box, Typography } from '@mui/material';

import { COLORS } from '@/styles/tokens/colors';

export function DefaultDataTableHeader({ children }: React.PropsWithChildren) {
  return (
    <Box p={1.5} mb={2} data-it="DataTable-headerContainer" component="header">
      <Typography color={COLORS.TEXT.PRIMARY} variant="title-l" component="h2">
        {children}
      </Typography>
    </Box>
  );
}
